import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-schedule',
	templateUrl: './icon-schedule.component.svg',
})
export class IconScheduleComponent {}
